import { render } from "./RecordClear.vue?vue&type=template&id=119ece9e"
import script from "./RecordClear.vue?vue&type=script&lang=js"
export * from "./RecordClear.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.9.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__